export default "__VITE_ASSET__DCgdxY1W__"